import { render, staticRenderFns } from "./IconRggjjtzhshgz.vue?vue&type=template&id=3c87f2b2"
import script from "./IconRggjjtzhshgz.vue?vue&type=script&lang=js"
export * from "./IconRggjjtzhshgz.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports